module.exports = __webpack_public_path__ + "media/halloween_tipping_tier_2-72d241f629887d08912465149db727dc.mp3";